export default class Manager {
  id: string
  account: string
  name: string
  constructor (id: string, displayName: string, username: string) {
    this.id = id
    this.name = displayName
    this.account = username
  }
}
